module.exports = "/static/assets/936c6f5135224fb98155587e33f3159f.gif";